// src/index.ts
var PricingType = /* @__PURE__ */ ((PricingType2) => {
  PricingType2["Monthly"] = "MONTHLY";
  PricingType2["Yearly"] = "YEARLY";
  return PricingType2;
})(PricingType || {});
var PRICING_CONFIG = {
  // Yearly discount percentage (yearly is 15% cheaper than monthly)
  yearlyDiscountPercent: 20,
  // Pricing tiers: monthly base prices
  tiers: [
    { maxRooms: 9, monthlyPrice: 12.5 },
    { maxRooms: 19, monthlyPrice: 12 },
    { maxRooms: 59, monthlyPrice: 10 },
    { maxRooms: 99, monthlyPrice: 7 },
    { maxRooms: 149, monthlyPrice: 6.5 },
    { maxRooms: 199, monthlyPrice: 6 },
    { maxRooms: 249, monthlyPrice: 5.5 },
    { maxRooms: Infinity, monthlyPrice: 5 }
  ]
};
function price(type, amountOfRooms) {
  if (!Object.values(PricingType).includes(type)) {
    throw new Error(
      `Invalid pricing type: ${type}. Must be 'MONTHLY' or 'YEARLY'.`
    );
  }
  if (!Number.isInteger(amountOfRooms) || amountOfRooms <= 0) {
    throw new Error("Amount of rooms must be a positive integer.");
  }
  const tier = PRICING_CONFIG.tiers.find((t) => amountOfRooms <= t.maxRooms);
  if (!tier) {
    throw new Error("No pricing tier found for room count.");
  }
  let unitPriceEuros = tier.monthlyPrice;
  if (type === "YEARLY" /* Yearly */) {
    const discountMultiplier = 1 - PRICING_CONFIG.yearlyDiscountPercent / 100;
    unitPriceEuros = tier.monthlyPrice * discountMultiplier;
  }
  const unitPrice = Math.round(unitPriceEuros * 100);
  const totalPrice = unitPrice * amountOfRooms;
  return { unitPrice, totalPrice };
}
export {
  PricingType,
  price
};
//# sourceMappingURL=index.js.map